module.exports = __webpack_public_path__ + "static/sample-18-85356421a2fb077db3bae4e99b0a56a1.png";